import { defineComponent, ref } from 'vue-demi';
import './OrTooltip-a15bf4b1.js';
import { s as script$1 } from './OrTooltipContent-c0042844.js';
import { s as script$2, O as OrFloatingPlacements } from './OrFloating-00617713.js';
import { p as pxToRem } from './px-to-rem-0b26b83e.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, mergeProps, renderSlot, createTextVNode, toDisplayString, createBlock, withCtx, createVNode, createCommentVNode } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';

var OrIconColors;
(function (OrIconColors) {
  OrIconColors["primary"] = "primary";
  OrIconColors["error"] = "error";
  OrIconColors["warning"] = "warning";
  OrIconColors["success"] = "success";
  OrIconColors["neutral-0"] = "neutral-0";
  OrIconColors["neutral-1"] = "neutral-1";
  OrIconColors["neutral-2"] = "neutral-2";
  OrIconColors["neutral-3"] = "neutral-3";
  OrIconColors["neutral-4"] = "neutral-4";
  OrIconColors["neutral-5"] = "neutral-5";
  OrIconColors["neutral-6"] = "neutral-6";
})(OrIconColors || (OrIconColors = {}));
var OrIconType;
(function (OrIconType) {
  OrIconType["outline"] = "outlined";
  OrIconType["filled"] = "filled";
  OrIconType["rounded"] = "round";
  OrIconType["sharp"] = "sharp";
  OrIconType["two-tone"] = "two-tone";
})(OrIconType || (OrIconType = {}));

var script = defineComponent({
  name: 'OrIcon',
  components: {
    OrTooltipContent: script$1,
    OrFloating: script$2
  },
  inheritAttrs: false,
  props: {
    iconType: {
      type: String,
      default: () => OrIconType.filled,
      required: false
    },
    icon: {
      type: String,
      default: '',
      required: false
    },
    color: {
      type: String,
      default: '',
      required: false
    },
    tooltipText: {
      type: String,
      default: null,
      required: false
    },
    tooltipPlacement: {
      type: String,
      default: () => OrFloatingPlacements.TOP,
      required: false
    },
    isDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    size: {
      type: Number,
      default: null
    }
  },
  setup() {
    const tooltipTrigger = ref();
    return {
      tooltipTrigger
    };
  },
  data() {
    return {
      tooltipIsShown: false
    };
  },
  computed: {
    iconClasses() {
      return ['or-icon', `material-icons${this.iconType === OrIconType.filled ? '' : `-${this.iconType}`}`, {
        'is-disabled': this.isDisabled,
        [`is-${this.color}-color`]: !!this.color,
        'with-tooltip': !!this.tooltipText
      }];
    },
    fontSize() {
      return Number.isInteger(this.size) ? {
        fontSize: pxToRem(this.size)
      } : null;
    },
    rootClasses() {
      return ['or-icon-root', this.$attrs.class];
    },
    localAttrs() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
      const {
        class: _,
        ...rest
      } = this.$attrs;
      return rest;
    }
  },
  methods: {
    showTooltip() {
      this.tooltipIsShown = true;
    },
    hideTooltip() {
      this.tooltipIsShown = false;
    }
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_tooltip_content = resolveComponent("or-tooltip-content");
  const _component_or_floating = resolveComponent("or-floating");
  return openBlock(), createElementBlock("span", {
    class: normalizeClass(_ctx.rootClasses)
  }, [createElementVNode("span", mergeProps({
    ref: "tooltipTrigger"
  }, _ctx.localAttrs, {
    class: _ctx.iconClasses,
    style: _ctx.fontSize,
    onMouseover: _cache[0] || (_cache[0] = (...args) => _ctx.showTooltip && _ctx.showTooltip(...args)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => _ctx.hideTooltip && _ctx.hideTooltip(...args))
  }), [renderSlot(_ctx.$slots, "default", {}, () => [createTextVNode(toDisplayString(_ctx.icon), 1 /* TEXT */)])], 16 /* FULL_PROPS */), _ctx.tooltipText && _ctx.tooltipIsShown ? (openBlock(), createBlock(_component_or_floating, {
    key: 0,
    trigger: _ctx.tooltipTrigger,
    placement: _ctx.tooltipPlacement,
    "is-using-shift": "",
    "is-using-flip": "",
    offset: 8
  }, {
    default: withCtx(() => [createVNode(_component_or_tooltip_content, {
      content: _ctx.tooltipText,
      placement: _ctx.tooltipPlacement,
      "is-shown": _ctx.tooltipIsShown
    }, null, 8 /* PROPS */, ["content", "placement", "is-shown"])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger", "placement"])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-4eab0c98 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-4eab0c98 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-icon-root[data-v-4eab0c98] {\n  position: relative;\n  display: inline-flex;\n}\n.or-icon[data-v-4eab0c98] {\n  display: inline-flex;\n  font-size: 1.25rem;\n  color: inherit;\n  user-select: none;\n  transition-timing-function: var(--t-func);\n  transition-duration: var(--t-duration);\n  transition-property: color;\n}\n.or-icon.with-tooltip[data-v-4eab0c98] {\n  cursor: pointer;\n}\n.or-icon.is-primary-color[data-v-4eab0c98] {\n  color: var(--c-primary);\n}\n.or-icon.is-warning-color[data-v-4eab0c98] {\n  color: var(--c-warning);\n}\n.or-icon.is-success-color[data-v-4eab0c98] {\n  color: var(--c-success);\n}\n.or-icon.is-error-color[data-v-4eab0c98] {\n  color: var(--c-error);\n}\n.or-icon.is-neutral-0-color[data-v-4eab0c98] {\n  color: var(--c-neutral-0);\n}\n.or-icon.is-neutral-1-color[data-v-4eab0c98] {\n  color: var(--c-neutral-1);\n}\n.or-icon.is-neutral-2-color[data-v-4eab0c98] {\n  color: var(--c-neutral-2);\n}\n.or-icon.is-neutral-3-color[data-v-4eab0c98] {\n  color: var(--c-neutral-3);\n}\n.or-icon.is-neutral-4-color[data-v-4eab0c98] {\n  color: var(--c-neutral-4);\n}\n.or-icon.is-neutral-5-color[data-v-4eab0c98] {\n  color: var(--c-neutral-5);\n}\n.or-icon.is-neutral-6-color[data-v-4eab0c98] {\n  color: var(--c-neutral-6);\n}\n.or-icon[data-v-4eab0c98]:disabled, .or-icon.is-disabled[data-v-4eab0c98] {\n  cursor: not-allowed;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-4eab0c98";
script.__file = "src/components/or-icon/OrIcon.vue";

export { OrIconColors as O, OrIconType as a, script as s };
